import React, { useEffect, useState } from 'react'

export const Navigation = (props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const handleMenuClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };
  return (
    <header>
    <div id='menu' className='navbar-default navbar-fixed-top' >
      <div className='container'>
        <div className="row">
          <div className="col-md-3 col-sm-12">
            <div className="navbar-header"> <a href="/"><img style={{ height: 60, overflow: 'hidden', }} src="img/logo.png" alt="logo" /></a> </div>
          </div>
          <div className="col-md-9 col-sm-12">
            <div className="contact-details">
              {/* <div className="col-md-4 "> */}
                <div className="phonea"> <i className="fa fa-phone"></i>&nbsp;&nbsp;<a href="tel:18008333318 "> 18008333318 </a> </div>
              {/* </div> */}

              {/* <div className="col-md-8 col-sm-12">
                <div className="phonea"><i className="fa fa-envelope-o"></i>
                  <a href="mailto:getwaterpurifierservices@gmail.com">getwaterpurifierservices@gmail.com</a> </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
    </header>
  )
}
